import {
  advertiseCollectionApi,
  collectionSearchApi,
} from '@/entities/collection';
import { convertCollectionListItem } from '@/shared/utils';

export const getRecommendedCollections = async () => {
  const [recommendedCollectionsData, advertiseCollectionData] =
    await Promise.all([
      collectionSearchApi({ ordering: 'editor_choice' }),
      advertiseCollectionApi({ location: 'editor_choice' }),
    ]);

  const recommendedCollections = recommendedCollectionsData.data.results.slice(
    0,
    3
  );
  const advertiseCollection = advertiseCollectionData.data.collection;

  const collections = convertCollectionListItem([
    ...recommendedCollections,
    advertiseCollection,
  ]).map((collection) => ({
    ...collection,
    scrapsLength: collection.scraps.length,
    isAdvertisement: collection.id === advertiseCollection.id,
  }));

  return collections;
};
